export default "__VITE_ASSET__e8904ecb__"